/**
 * Web shim for react-native-background-geolocation.
 *
 * The real SDK throws at import time on web ("Native module
 * RNBackgroundGeolocation not found"), which broke every route chunk whose
 * import graph touched it — explore pulls it transitively through
 * lib/api/trails -> utils/permissions. Web is browse-only (explore, packs,
 * profile, trail detail), so a harmless stub is enough: recording flows
 * that somehow run on web reject and land in their existing catch paths.
 */
const Subscription = () => ({ remove() {} });
const notSupported = () => Promise.reject(new Error('Background geolocation is not supported on web'));

const BackgroundGeolocation = {
  // State reads report "supported but disabled" so permission/UI checks degrade.
  async ready() { return { enabled: false }; },
  async getState() { return { enabled: false, authorization: 'DENIED' }; },
  async getProviderState() { return { enabled: false, status: 0 }; },
  async start() {},
  async stop() {},
  async changePace() {},
  async requestPermission() { return notSupported(); },
  async getCurrentPosition() { return notSupported(); },
  async getLocations() { return notSupported(); },
  onLocation: Subscription,
  onMotionChange: Subscription,
  onProviderChange: Subscription,
  onAuthorization: Subscription,
  onHeartbeat: Subscription,
  onEnabledChange: Subscription,
  onPowerSaveChange: Subscription,
  removeListeners() {},

  AuthorizationStatus: {
    Always: 'ALWAYS',
    WhenInUse: 'WHEN_IN_USE',
    Denied: 'DENIED',
    NotDetermined: 'NOT_DETERMINED',
  },
  DESIRED_ACCURACY_NAVIGATION: -2,
  DESIRED_ACCURACY_HIGH: -1,
  DESIRED_ACCURACY_MEDIUM: 10,
  DESIRED_ACCURACY_LOW: 100,
  DESIRED_ACCURACY_LOWEST: 1000,
  ACTIVITY_TYPE_OTHER: 1,
  ACTIVITY_TYPE_AUTOMOTIVE: 2,
  ACTIVITY_TYPE_FITNESS: 3,
  ACTIVITY_TYPE_AIRBORNE: 4,
  NOTIFICATION_PRIORITY_DEFAULT: 0,
  NOTIFICATION_PRIORITY_MIN: -2,
  NOTIFICATION_PRIORITY_LOW: -1,
  NOTIFICATION_PRIORITY_HIGH: 2,
  NOTIFICATION_PRIORITY_MAX: 2,
  LOG_LEVEL_OFF: 0,
  LOG_LEVEL_ERROR: 1,
  LOG_LEVEL_WARNING: 2,
  LOG_LEVEL_INFO: 3,
  LOG_LEVEL_DEBUG: 4,
  LOG_LEVEL_VERBOSE: 5,
};

module.exports = BackgroundGeolocation;
module.exports.default = BackgroundGeolocation;
module.exports.__esModule = true;